(function () {
    'use strict';
    var m = angular.module('app');
    m.directive('page', ["path", "$route", "feature", function (path, $route, feature) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('main').directive('page').template(),
            transclude: {
                top: '?top',
                content: 'content'
            },
            scope: { noTop: '=?' },
            link: function ($scope, element, attrs) {
                $scope.$route = $route;
                $scope.$watch('$route.current', function (newVal) {
                    if (newVal && newVal.$$route) {
                        var wrapperTitle = newVal.fullTitle || newVal.$$route.fullTitle || newVal.$$route.title;
                        if (newVal.$$route.themeTitle) {
                            _(newVal.$$route.themeTitle).each(function (title, theme) {
                                if (feature[theme]) {
                                    wrapperTitle = title;
                                }
                            });
                        }
                        $scope.title = wrapperTitle;
                    }
                });
            }
        };
    }]);
}());